class VideoReviewsCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.thumbnails = this.querySelector(".video-reviews-carousel--thumbnails");
    this.videos = this.querySelector(".video-reviews-carousel--main-video");
    this.thumbnails.addEventListener(
      "click",
      this.thumbnailEventHandler.bind(this)
    );
  }

  disconnectedCallback() {
    this.thumbnails.removeEventListener(
      "click",
      this.thumbnailEventHandler.bind(this)
    );
  }

  thumbnailEventHandler(event) {
    const btn = event.target.closest("button");
    if (!btn) return;
    const { reviewIndex } = btn.dataset;
    this.toggleVideoReviews(reviewIndex);
  }

  toggleVideoReviews(index) {
    // Select the container for the new active video based on the clicked thumbnail
    const newActiveVideoContainer = this.videos.querySelector(
      `[data-review-index="${index}"]`
    );

    // Pause all videos that are not within the new active video container
    const videoElements = this.videos.querySelectorAll("video");
    videoElements.forEach(video => {
      if (!newActiveVideoContainer.contains(video)) {
        video.pause();
      }
    });

    // Play the video inside the new active container, whether the container is the video itself or it wraps one
    let newActiveVideo = newActiveVideoContainer.tagName.toLowerCase() === "video"
      ? newActiveVideoContainer
      : newActiveVideoContainer.querySelector("video");
    if (newActiveVideo) newActiveVideo.play();

    // Toggle dataset attributes for active state
    const prevActiveVideo = this.videos.querySelector(`[data-show-review="true"]`);
    if (prevActiveVideo) prevActiveVideo.dataset.showReview = false;
    newActiveVideoContainer.dataset.showReview = true;

    // Scroll the new active video container into view smoothly
    newActiveVideoContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}
customElements.define("video-reviews-carousel", VideoReviewsCarousel);
